import { render, staticRenderFns } from "./addEquipamento.vue?vue&type=template&id=70814531&scoped=true&"
import script from "./addEquipamento.vue?vue&type=script&lang=js&"
export * from "./addEquipamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70814531",
  null
  
)

export default component.exports